import React, {Component} from 'react'
import {connect} from 'react-redux'
import {
  getTextFilterCfg,
  getEditIconColumn,
  getSelectFilterCfg
} from '../grid/ColumnHelpers'

import {guiSet} from '../../actions/uiActions'

import Grid from '../grid/Grid'
import { 
    pazemesRisksUnIznemumsDoubleSelected, 
    pazemesRisksUnIznemumsSelected 
} from '../../actions/riskiUnIznemumiActions';

const editIconColumn = getEditIconColumn((row) => (
    {
        type: `loc_pazemes_risks_un_iznemumi_ieraksts`,
        payload: {
            id: row.id,
            kods: row.uo_kods
        }
    }
))

class PazemesRiskiUnIznemumiSaraksts extends Component {

    rowEvents = {
        onDoubleClick: (e, row, rowIndex) => {
            this.props.pazemesRisksUnIznemumsDoubleSelected(row)
        }
    }

    render() {
        const getColumns = ({kodif}) => {
            return [editIconColumn, {
                dataField: 'uo_kods',
                text: 'ŪO kods',
                filterCfg: getTextFilterCfg(),
                width: 100
            }, {
                dataField: 'uo_nosaukums',
                text: 'Ūdens objekts',
                filterCfg: getTextFilterCfg(),
                width: 200
            }, {
                dataField: 'gads',
                text: 'Riska izvērtējuma gads',
                filterCfg: {
                    type: 'autocomplete',
                    autocompleteCfg: {
                        remoteSearchViewName: 'pazemes_udens_objekts_riski_gads_distinct_search'
                    }
                }
            }, {
                dataField: 'periods',
                text: 'UBAP periods',
                filterCfg: getSelectFilterCfg(kodif.UO_PERIODS)
            }, {
                dataField: 'kvantitate',
                text: 'Risks (kvantitāte)',
                filterCfg: getTextFilterCfg()
            }, {
                dataField: 'kvalitate',
                text: 'Risks (kvalitāte)',
                filterCfg: getTextFilterCfg()
            }, {
                dataField: 'iznemumi',
                text: 'Izņēmumi',
                filterCfg: getSelectFilterCfg(kodif.pazemesUdensObjektaIznemumi)
            }]
        }
        
        if(!this.columns){
            this.columns = getColumns({
                kodif: this.props.kodif
            })
        }

        return (
            <div className="saraksts-wrapper">
                <Grid
                    onRowSelected={this.props.pazemesRisksUnIznemumsSelected}
                    loading={this.props.pazemesRiskiUnIznemumiList.loading}
                    selectedId={this.props.pazemesRiskiUnIznemumiList.selected}
                    dataList={this.props.pazemesRiskiUnIznemumiList.list}
                    totalCount={this.props.pazemesRiskiUnIznemumiList.count}
                    columns={this.columns}
                    rowEvents={this.rowEvents}
                />            
            </div>
        )
    }
}

const mapStateToProps = ({pazemesRiskiUnIznemumiList, kodif, gui, user}) => {
  return {pazemesRiskiUnIznemumiList, kodif, gui, user}
}

export default connect(mapStateToProps, {pazemesRisksUnIznemumsSelected, guiSet, pazemesRisksUnIznemumsDoubleSelected})(PazemesRiskiUnIznemumiSaraksts)
